/* global APPCUES_API_URL */
import { takeEvery, getContext } from "redux-saga/effects";
import { HIT_PUBLISH_HOOK } from "constants/actionTypes";

export function* hitPublishHook() {
  const auth = yield getContext("auth");
  const token = yield auth.getToken();
  const id = yield auth.getAccountId();
  const response = yield fetch(`${APPCUES_API_URL}/v1/accounts/${id}/publish`, {
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
}

export default function*() {
  yield takeEvery(HIT_PUBLISH_HOOK, hitPublishHook);
}
